import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CapabilityView } from '../../classes/models/employee/CapabilityView';
import { CapabilityViewResponse } from '../../interfaces/response/EmployeeResponse';
import { CapabilityViewAdapter } from '../../classes/adapters/response/employee/CapabilityViewAdapter';

/**
 * This service communicates with backend to retrieve capability views.
 */
@Injectable({
  providedIn: 'root'
})
export class CapabilityService {
  private http = inject(HttpClient);
  private capabilityViewAdapter = inject(CapabilityViewAdapter);

  url = environment.apiUrl + '/capability';

  /**
   * Retrieves a map of employee capability records by the day for a specific store.
   * @param storeId an identifier of a store.
   * @param startDate the date starting from which capability requirements takes effect.
   */
  getCapabilityViews(storeId: string, startDate: string): Observable<CapabilityView[]> {
    const url = `${this.url}/${storeId}/${startDate}`;
    return this.http.get(url).pipe(
      map((item: CapabilityViewResponse[]) => this.capabilityViewAdapter.adapt(item)));
  }
}
